import { GlassCard } from "@kj/design-system";

export default function ReportsPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">User Reports</h1>
      <GlassCard padding="lg" radius="2xl">
        <div className="text-sm text-fg-muted text-center py-10">
          신고 큐 비어 있음. 사용자·AI 모더레이션 신고가 여기로 들어옵니다.
        </div>
      </GlassCard>
    </div>
  );
}
